import { useAppSelector } from '@/hooks/redux-hooks';

export const useLatestApiKey = () => {
  return useAppSelector(
    state =>
      [...(state.listApiKey?.apiKeyOutputs ?? [])]
        .sort((a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime())
        .at(-1)?.prefixedRawApiKey
  );
};
